module.exports = __webpack_public_path__ + "static/img/04.5e37cfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour6/04.jpg
// module id = /8do
// module chunks = 0